import React from 'react'

const Accessories = () => {
  return (
    <div>
      <section class="inner-banner">
        <div class="thm-container">
          <h2> Product Details </h2>
          <div class="breadcumb">
            <a href="/">Yokogawa</a>
            <i class="fa fa-angle-right"></i>
            <span>Accessories </span>
          </div>
        </div>
      </section>
      <div className='container py-4'>
        <div>
          <h1 className='text-center ' style={{ textDecoration: "underline" }}>Accessories</h1>
        </div>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/cable1.png' style={{marginRight:"40px"}} />
            <img src='/img/cable2.png' style={{marginRight:"40px"}} />
            <img src='/img/cable3.png' style={{marginRight:"40px"}} />
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Cables:</h2>
            <p className="mbot25">
              Probe cables, lead cords, output, extension, and connection cables,
              alligator clips, BNC, USB, and more.
            </p>
          </div>
        </div>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Probes:</h2>
            <p class="mbot25">
              Differential probes, Logic probes, Active probes, Passive probes,
              Miniature Passive probes, Clamp-on probes e.t.c.
            </p>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/probes1.png' style={{marginRight:"40px"}}/>
            <img src='/img/probes2.png' style={{marginRight:"40px"}}/>
            <img src='/img/probes3.png' style={{marginRight:"40px"}}/>
          </div>
        </div>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/modules.png' width={400} ></img>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Modules:</h2>
            <p className="mbot25">
              Isolation Modules, Voltage modules, Temperature Input Module
              Strain Input Modules, Frequency Modules, Logic Input Modules
              Auxillary Modules, and more.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Accessories
